/**
 * Utility to handle character encoding issues.
 * This fixes cases where special characters like © are double or triple encoded.
 */

export const fixEncodingCorruption = (str) => {
  if (typeof str !== "string" || !str) return str;

  let repaired = str;
  let previous;

  for (let i = 0; i < 3; i++) {
    previous = repaired;
    try {
      const decoded = decodeURIComponent(escape(repaired));
      if (decoded !== repaired) {
        repaired = decoded;
      } else {
        break;
      }
    } catch (e) {
      break;
    }
    if (repaired === previous) break;
  }

  return repaired;
};

/**
 * Encodes special characters to HTML entities to ensure safe transmission and storage.
 * This prevents double-encoding issues on the backend.
 */
export const encodeToHtmlEntities = (str) => {
  if (typeof str !== "string" || !str) return str;

  const repaired = fixEncodingCorruption(str);

  return repaired.replace(/[\u00A0-\u9999<>\&]/gim, (i) => {

    if (i === '<' || i === '>' || i === '&') {
      if (i === '&') return '&amp;';
      return i;
    }

    return '&#' + i.charCodeAt(0) + ';';
  });
};

export const prepareDescriptionPayload = (html) => {
  if (!html) return "";

  return fixEncodingCorruption(html);
};
